// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + "editEvent" + "." + "2b7cb485fc70558ac375" + ".bundle.js";
};